/*
 * @Author: 脉迈
 * @Date: 2020-12-21 16:14:33
 * @LastEditors: 脉迈
 * @LastEditTime: 2021-08-19 14:48:19
 */
import FN from './fn'
// import store from '../store'
function getCookie (name) {
  var strcookie = document.cookie// 获取cookie字符串
  var arrcookie = strcookie.split('; ')// 分割
  // 遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split('=')
    if (arr[0] === name) {
      return arr[1]
    }
  }
  return ''
}
const global = {
  fuseLogin (res) {
    window.MJFUSESDK.login({
      user_id: res.data.old_id, // 从客户端获取的用户id,方便排查问题。比如步步高
      phone: res.data.phone, // 用户电话号码
      is_bind_phone: res.data.phone ? 1 : 0, // 是否绑定手机号码  1 是  0 不是
      is_realname: res.data.real_name_status, // 是否实名    1 是  0 不是
      data: JSON.stringify({
        uid: res.data.old_id,
        time: res.data.timestamp,
        sign: res.data.sign,
        wx_user: getCookie('wxcdninfo') // 微信登录获取cookie存储的openid
      }),
      ext: JSON.stringify(window.__ext__ || {})
    })
      .then(res2 => {
        if (res2.code === 0) {
        // 保存融合登录用户信息
          if (res2.code === 0) {
          // 保存融合登录用户信息
            FN.log('融合登录')
            FN.saveSession('FUSE_USER_INFO', res2.data)
            FN.saveLocal('FUSE_USER_INFO', res2.data)
          }
          if (window.SDKDATA.loginWay) {
            // 调用usesdk.js中的登录
            window.SDKDATA.login.callback(res)
          } else {
            window.SDKDATA.flymeChangeAccount.callback(res)
          }
        }
      })
  },
  saveAccount (res) {
    // ！！！ 保存登录记录
    let loginRecord = Array.isArray(FN.getLocal('LOGIN_RECORD'))
      ? FN.getLocal('LOGIN_RECORD')
      : []

    let newRecord = {
      account: res.data.name, // 用于展示的帐号名， 帐号登录时 account == name， 手机登录时 account == phone
      name: res.data.name, // 实际登录时都是使用 name 和 password
      password: res.data.password
    }
    // 如有重复数据就删除，重新添加到队首
    loginRecord.forEach((item, index) => {
      if (item.name === newRecord.name) {
        // 使用name判断才能确保唯一性
        loginRecord.splice(index, 1)
      }
    })

    loginRecord.unshift(newRecord)
    // 最多保存5条数据
    loginRecord = loginRecord.slice(0, 5)
    FN.saveLocal('LOGIN_RECORD', loginRecord)
  }
}
export default global
